import React from 'react';
import Tatvar from './tatvar';

const PageList = () => <Tatvar />;

export default PageList;
